
const minutesToHours = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${remainingMinutes
    .toString()
    .padStart(2, '0')}`;
};

const hoursToMinutes = (hours) => {
  // Convertir horas decimales (ej: 1.5) a minutos (ej: 90)
  return Math.round(hours * 60);
};

const formatNumber = (value) => {
  // Si el valor es null, undefined o no es un número válido, retornar el valor original
  if (value === null || value === undefined || value === '' || isNaN(value)) {
    return value;
  }
  
  // Convertir a número si es string
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  // Si no es un número válido después de la conversión, retornar el valor original
  if (isNaN(num)) {
    return value;
  }
  
  // Formatear con separadores de miles usando punto como separador
  return new Intl.NumberFormat('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(num);
};

export { minutesToHours, hoursToMinutes, formatNumber };
